import { createContext, useContext } from 'react';

/**
 * The search modal's own <dialog> element, for overlays that must cover the
 * WHOLE modal (the offer popup) to portal into.
 *
 * Why not render them where they are used: a `position: fixed` overlay is only
 * "full screen" while no ancestor captures it. Inside a product card it sits
 * under the results scroll container, and on iPhone that container confines it
 * — the popup opened under the search bar with its × out of reach (syfak,
 * 2026-10-27). In Chrome a card's entry animation (a transform) did the same
 * for 400ms: the overlay measured 185px tall, exactly the card. The dialog is
 * the one element nothing in the modal can be an ancestor of.
 *
 * `null` outside the modal (or before it has mounted) — callers then render in
 * place, exactly as before.
 */
export const ModalLayerContext = createContext<HTMLElement | null>(null);

export function useModalLayer(): HTMLElement | null {
  return useContext(ModalLayerContext);
}
